export default __webpack_public_path__ + "static/chartIcon2-a53ea068a4ba261987e1e7e7d974c943.png";